import { StandardCard } from '@juvare/common-web-ui/Cards/StandardCard';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Typography } from '@mui/material';
import React from 'react';
export const ImportDialogCard = (props) => {
    return (React.createElement(StandardCard, { sx: {
            backgroundColor: themeColors.surface.secondary,
            border: 0,
            p: 2,
        } },
        React.createElement(Box, { sx: { display: 'flex', gap: 1 } },
            props.icon,
            React.createElement(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 0.5,
                } },
                React.createElement(Typography, { variant: 'subtitle2', sx: { color: themeColors.text.main } }, props.title),
                typeof props.description === 'string' ? (React.createElement(Typography, { variant: 'body2', sx: { color: themeColors.text.subtle } }, props.description)) : (props.description)))));
};
